import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Work',
    path: '/work'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-424">
      <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-425">
        <div className="flex items-center justify-between" data-id="element-426">
          <Link to="/" className="flex items-center" data-id="element-427">
            <img src="https://cdn.magicpatterns.com/uploads/qZq5o2kR7qajKU24kpFCJC/blogo.svg" alt="Belo Digital" className="h-8 w-auto" data-id="element-428" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-429">
            {navLinks.map(link => <Link key={link.name} to={link.path} className="text-sm font-medium text-gray-700 hover:text-[#FF6600] hover:font-bold transition-all" data-id="element-430">
                {link.name}
              </Link>)}
            <Link to="/contact" data-id="element-431">
              <Button data-id="element-432">Start a Project</Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-[#0C0C0C]" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-433">
            {isOpen ? <X size={24} data-id="element-434" /> : <Menu size={24} data-id="element-435" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-436">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-437">
            <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-438">
              {navLinks.map(link => <Link key={link.name} to={link.path} className="text-lg font-medium text-gray-800 hover:text-[#FF6600] hover:font-bold transition-all" onClick={() => setIsOpen(false)} data-id="element-439">
                  {link.name}
                </Link>)}
              <Button className="w-full mt-4" onClick={() => setIsOpen(false)} data-id="element-440">
                Start a Project
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}